import React, { useState, useEffect } from "react";

import {
  Container,
  Box,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

import { formatNumber, filterByRegion, sortByName } from "../../helpers";
import MobileLookup from "./MobileLookup";
import "./style.css";
import { getCountryData } from "../../api";
import { regions } from "../../data";
const Lookup = () => {
  const [region, setRegion] = useState("World");
  const [selectedStat, setSelectedStat] = useState("country");
  const [countryData, setCountryData] = useState([]);
  useEffect(() => {
    const fetchCountryData = async () => {
      let data = await getCountryData();
      setCountryData(sortByName(filterByRegion([...data], region)));
    };
    fetchCountryData();
  }, [region]);

  const sortFormattedNumber = (a, b) =>
    +a.replace(/,/g, "") - +b.replace(/,/g, "");

  const getRankForStat = (countryName) => {
    if (["capital", "region", "flag", "country"].includes(selectedStat)) {
      return "-";
    }

    let countriesSortedByStat = [...countryData].sort(
      (a, b) => b[selectedStat.toLowerCase()] - a[selectedStat.toLowerCase()]
    );

    return (
      countriesSortedByStat.findIndex(
        (country) => country.name === countryName
      ) + 1
    );
  };

  const columns = [
    { field: "id", headerName: "ID", hide: true },
    { field: "rank", headerName: "#", flex: 0.05, sortable: false },
    {
      field: "flag",
      headerName: "Flag",
      flex: 0.05,
      sortable: false,
      align: "center",
      renderCell: (params) => (
        <img
          height="22px"
          alt={params.value}
          src={params.value}
          style={{ aspectRatio: "3/2" }}
        />
      ),
    },
    { field: "country", headerName: "Country", flex: 1 },
    { field: "capital", headerName: "Capital", flex: 1 },
    { field: "region", headerName: "Region", flex: 0.7 },
    {
      field: "population",
      headerName: `Population`,
      flex: 1,
      sortComparator: sortFormattedNumber,
    },
    {
      field: "area",
      headerName: `Area (km${"\u00B2"})`,
      flex: 1,
      sortComparator: sortFormattedNumber,
    },
    {
      field: "density",
      headerName: `Density`,
      flex: 0.8,
      sortComparator: sortFormattedNumber,
    },
  ];
  const rows = countryData.map((country, idx) => {
    return {
      id: idx + 1,
      rank: getRankForStat(country.name),
      flag: country.flag,
      country: country.name,
      region: country.region,
      capital: country.capital,
      population: formatNumber(country.population),
      area: formatNumber(country.area),
      density: formatNumber(country.density),
    };
  });

  return window.innerWidth < 725 ? (
    <MobileLookup />
  ) : (
    <Container
      maxWidth={false}
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        overflow: "scroll",
      }}
    >
      <FormControl sx={{ width: "30%", margin: "1rem 0" }}>
        <InputLabel id="region-select">
          <Typography variant="overline">Region</Typography>
        </InputLabel>
        <Select
          id="region-select"
          value={region}
          onChange={(e) => {
            setRegion(e.target.value);
          }}
          label={<Typography variant="overline">Region</Typography>}
          MenuProps={{ PaperProps: { sx: { maxHeight: 350 } } }}
        >
          {regions.map((region, idx) => {
            return (
              <MenuItem value={region} key={idx + 1}>
                {region}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
      <Box sx={{ height: "100vh", width: "100%", margin: "auto" }}>
        <DataGrid
          rows={rows}
          columns={columns}
          disableColumnFilter
          disableColumnMenu
          disableExtendRowFullWidth
          getRowHeight={() => "auto"}
          rowsPerPageOptions={[10, 20, 50, 100]}
          sx={{ border: "none" }}
          onColumnHeaderClick={(e) => {
            if (
              ["capital", "region", "flag", "country", "rank"].includes(e.field)
            ) {
              return;
            }

            setSelectedStat(e.field);
          }}
        />
      </Box>
    </Container>
  );
};

export default Lookup;
